import { jsx as _jsx } from "react/jsx-runtime";
import { MessageBar, StackLayout } from "@advosys/component-react";
import { useT } from "./module-access-error-i18n";
export const ModuleAccessError = () => {
    const { t } = useT();
    return (_jsx(StackLayout, { horizontal: true, horizontalAlign: "center", verticalAlign: "center", children: _jsx(MessageBar, { messageBarType: "error", children: t.errorMessage }) }));
};
